import { render, staticRenderFns } from "./LaserIcon.vue?vue&type=template&id=73f4d536&"
import script from "./LaserIcon.vue?vue&type=script&lang=ts&"
export * from "./LaserIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports